import { createError, useNuxtApp } from 'nuxt/app'
import { setActivePinia } from 'pinia'

import { useLocationStore } from '@common/location-layer/store/location.store'

import { isCPLegalPagesLocation, isCPLegalRoutePath } from '../constants/legal-pages.constants'

import type { Pinia } from 'pinia'

/**
 * `/legal/*` is a location-allowlisted public surface. Runs before auth.global so
 * non-pilot locations 404 instead of bouncing to login.
 */
export default defineNuxtRouteMiddleware(to => {
  if (!isCPLegalRoutePath(to.path)) return

  const nuxtApp = useNuxtApp()
  const pinia = nuxtApp.$pinia as Pinia | undefined
  if (!pinia) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
  }

  setActivePinia(pinia)

  const locationStore = useLocationStore(pinia)
  const locationId = locationStore.locationId || locationStore.locationData?.locationId
  // Location plugin may run after this middleware on SSR. An empty id must not 404
  // (that hid the page behind login). Re-check on the client once the store is filled.
  if (!locationId || isCPLegalPagesLocation(locationId)) return

  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
})
